
import { WorkplaceShutdownModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { workplaceShutdownsStore } from '@/libs/workplaces/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import WorkplaceShutdownDialog from '../components/WorkplaceShutdownDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        WorkplaceShutdownDialog,
    },
})
export default class WorkplaceShutdowns extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('workplaceShutdowns.workplace'), value: 'workplace.name', align: 'left', sortable: false },
            { text: this.$i18n.t('workplaceShutdowns.fromDate'), value: 'fromDate', align: 'left', sortable: false },
            { text: this.$i18n.t('workplaceShutdowns.toDate'), value: 'toDate', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: WorkplaceShutdownDialog | null;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v && !isNaN(v) ? v.toString() : '10';
    }

    get loading(): boolean {
        return workplaceShutdownsStore.useGetter(CrudGetter.Pending);
    }

    get shutdowns(): WorkplaceShutdownModel[] {
        const data = workplaceShutdownsStore.useGetter(CrudGetter.Data);
        return data ? [...data] : [];
    }

    get totalRows(): number {
        const stats = workplaceShutdownsStore.useGetter(CrudGetter.DataStats) as CrudDataStats | undefined;
        return stats?.rowCount ?? 0;
    }

    mounted() {
        const stored = window.localStorage.amsItemsPerPage;
        this.itemsPerPage = stored && !isNaN(Number(stored)) ? Number(stored) : 10;
        this.load();
    }

    load() {
        workplaceShutdownsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<WorkplaceShutdownModel>(
            { field: 'fromDate', index: 1, order: 'desc' },
            this.getFilters()
        );
    }

    open(item: WorkplaceShutdownModel) {
        if (this.dialog && typeof (this.dialog as any).open === 'function') {
            (this.dialog as any).open(item.id!);
        }
    }

    createItemClick() {
        if (this.dialog && typeof (this.dialog as any).open === 'function') {
            (this.dialog as any).open(Guid.EmptyGuid());
        }
    }
}
